import { HttpService } from './index'
import qs from 'qs'

export default abstract class AbstractProvider {
  protected urlPath: string

  constructor(protected http: HttpService, protected baseUrl: string) {}

  protected get url(): string {
    return `${this.baseUrl}/${this.urlPath}.php`
  }

  protected get query() {
    return qs
  }

  protected getCustomUrl(url: string): string {
    return `${this.baseUrl}/${url}.php`
  }
}
